module.exports = __webpack_public_path__ + "static/img/product_images_big05_h5_zh.c21bc2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big05_h5_zh.png
// module id = us6z
// module chunks = 34